import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Popconfirm,
  Radio,
  RadioChangeEvent,
  Select,
  Spin,
  Table,
} from 'antd';
import { ColumnsType } from 'antd/lib/table';
import {
  ApplicantDetails,
  createLink,
  CreateLinkPayload,
  FeeCodes,
  FeesDetails,
  FeesPayload,
  getApplicantDetails,
  getFeesChargeDetails,
  LinkPayload,
} from 'api/agent';
import { LoadingScreen } from 'common/components';
import moment from 'moment';
import type { Moment } from 'moment';
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

let applicantPayload: LinkPayload = {};
let appDetails: ApplicantDetails[] = [];

// const newData: FeesDetails = {
//   feeCode: undefined,
//   feeDesc: undefined,
//   amount: undefined,
//   key: 100,
// };
// let feesList: FeesRespose = {
//   data: [],
// };

const { Option } = Select;
let _defFeeCodes: FeeCodes[] = [{}];

let recipients: ApplicantDetails[] = [];
let man: ApplicantDetails = {
  key: '',
  loanType: undefined,
  eMISiPiAmount: undefined,
  overdueAmount: undefined,
  totalAmount: undefined,
  currentMonthINST: undefined,
  allowedAmount: undefined,
  accountName: undefined,
  mobileNumber: undefined,
  customerName: undefined,
  loanBranch: undefined,
  emailId: undefined,

};
const initFees: FeesDetails[] = [];
// const filterPayload: FilterPayload = {
//   Username: sessionStorage.getItem('user')?.toString(),
//   SourceApplicationName: sessionStorage.getItem('source')?.toString(),
// };

const CreateLink = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<LinkPayload>();
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchedClicked, setSearchClicked] = useState(false);
  const [isSendClicked, setSendClicked] = useState(false);
  const [isFeesSelected, setFeesSelected] = useState(false);
  const [isForeclosure, setForeclosure] = useState(false);
  const [showForeclosureDates, setShowForeclosureDates] = useState(false);
  const [applicantDetails, setApplicantDetails] = useState(appDetails);
  // const [feeDetails, setFeeDetails] = useState(feesList);
  const [fees, setNewFees] = useState(initFees);
  const [isfeeLoaded, setFeeLoaded] = useState(false);
  const [value, setValue] = useState(0);
  const [feeCodes, _setFeeCodes] = useState(_defFeeCodes);
  const [manual, setManual] = useState(man);
  const [blank, isBlank] = useState(false);
  const [zero, setZero] = useState(false);
  const [loadedLoanNumber, setLoadedLoanNumber] = useState<string | null>(null);
  //const [amount, setAmount] = useState(0);
  const inputRef = useRef<HTMLInputElement>(null);
  // const [isModalLoading, setIsModalLoading] = useState(false);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [filter, setFilter] = useState(filterPayload);
  const disabledDate = (current: Moment) => {
    // Can not select days after today
    return current && current > moment().endOf('day');
  };

  const columns: ColumnsType<ApplicantDetails> = [
    {
      key: 'customerName',
      dataIndex: 'customerName',
      title: 'Name',
      width: '200',
      render: (_text, record) => {
        return (
          <Form.Item
            // name="customerName100"
            name={'customerName' + record.key} initialValue={record.customerName}
          >
            <Input
              type="text"
              value={record.customerName}
              disabled={record.key != 100 ? true : false}
              placeholder={'Customer Name'}
              style={{ height: '44px' }}
              onBlur={handleManualName}
            />
          </Form.Item>
        );
      },
    },
    {
      key: 'emailId',
      dataIndex: 'emailId',
      title: 'Email Id',
      width: '200',
      render: (_text, record) => (
        // record.key == 100 ? (
        //   <Form.Item
        //     name={'emailID ' + record.customerName}
        //     className=""
        //     rules={[{ required: true, type: 'email', message: 'Please Enter Valid Email Address!' }]}
        //     initialValue={record.emailId}
        //   >
        //     <Input
        //       type="email"
        //       value={record.emailId}
        //       disabled={record.key != 100 ? true : false}
        //       placeholder={'Enter EmailID'}
        //       style={{ height: '44px' }}
        //       onBlur={handleManualEmail}
        //     />
        //   </Form.Item>) :
        //   (
        <Form.Item name={'email' + record.key} initialValue={record.emailId}>
          <Input
            type="text"
            value={record.emailId}
            disabled={record.key != 100 ? true : false}
            placeholder={'Enter EmailID'}
            style={{ height: '44px' }}
            onBlur={handleManualEmail}
          />
        </Form.Item>
        // )
      ),
    },
    {
      key: 'accountName',
      dataIndex: 'accountName',
      title: 'Relationship',
      width: '200',
      render: (_text, record) => (
        <Form.Item name={'relationship' + record.key} initialValue={record.accountName}>
          <Input
            type="text"
            value={record.accountName}
            disabled={record.key != 100 ? true : false}
            placeholder={'Account Name'}
            style={{ height: '44px' }}
            onBlur={handleManualRel}
          />
        </Form.Item>
      ),
    },
    {
      key: 'mobileNumber',
      dataIndex: 'mobileNumber',
      title: 'Mobile Number',
      width: '200',
      render: (_text, record) => (

        <Form.Item
          name={'mobileNumber' + record.key}

          initialValue={record.mobileNumber}
        >
          <InputNumber
            type="text"
            value={record.mobileNumber}
            disabled={record.key != 100 ? true : false}
            placeholder={'Enter Mobile No'}
            onBlur={handleManualMobile}
          />
        </Form.Item>
        // )
      ),
    },
  ];

  function handleSend(values: any) {
    form.validateFields();

    const formLoanNumber = form.getFieldValue('loanNumber')?.toString();
    console.log('Current Loan Number from form:', formLoanNumber);
    console.log('Last loaded Loan Number:', loadedLoanNumber);

    // 🟢 New validation check to prevent sending stale data
    if (formLoanNumber !== loadedLoanNumber) {
      message.destroy();
      message.error('Please click "Search" to fetch details for the new loan number.');
      return; // Stop the submission process
    }
    // New logic to ensure applicant details are present before sending.
    // if (applicantDetails.length === 0) {
    //   message.error('Please click Search to fetch applicant details before sending.');
    //   return;
    // }

    // Get the current loan number from the form and from the loaded applicant details.
    // const formLoanNumber = form.getFieldValue('loanNumber')?.toString();
    // const selectedRecipientLoanNumber = recipients[0]?.laNumber?.toString();

    // Add console.log() to check the values
    // console.log('Form Loan Number:', formLoanNumber);
    // console.log('Selected Recipient Loan Number:', selectedRecipientLoanNumber);

    // Check if the loan number in the form does not match the loan number of the loaded data.
    // if (formLoanNumber !== selectedRecipientLoanNumber) {
    //   message.error('The applicant details are outdated. Please click Search to fetch details for the new loan number.');
    //   return;
    // }

    let manual = recipients.filter((x) => x.key == 100).length;
    const regexEmail = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    const regexMobile = RegExp(/^[0-9]{10}$/);
    let isFormValid = true;
    if (manual > 0) {
      let manualemail = form.getFieldValue('email100');
      let manualMobile = form.getFieldValue('mobileNumber100');
      let manualCustomerName = form.getFieldValue('customerName100');
      let manualRelationshipValue = form.getFieldValue('relationship100');

      console.log("Fetched values:");
      console.log("  manualemail:", manualemail);
      console.log("  manualMobile:", manualMobile);
      console.log("  manualCustomerName:", manualCustomerName);
      console.log("  manualRelationshipValue:", manualRelationshipValue);


      const valEmail = regexEmail.test(manualemail);
      const valMobile = regexMobile.test(manualMobile);
      // const valdMobile = regexMobile.test(manualRelationshipValue);
      //const valCustomer = regexEmail.test(manualCustomerName);
      //const valRelationship = regexMobile.test(manualRelationshipValue);
      console.log("Regex test results:");
      console.log("  valEmail (is manualemail valid?):", valEmail);
      console.log("  valMobile (is manualMobile valid?):", valMobile);

      // --- MODIFICATION START ---

      // For Customer Name: Check if it's not empty or just whitespace.
      // You might want a more specific regex if there are format requirements for names.
      const Name = manualCustomerName && manualCustomerName.trim().length > 0;

      // For Relationship: Check if it's not empty or just whitespace.
      const isValidManualRelationship = manualRelationshipValue && manualRelationshipValue.trim().length > 0;
      console.log("Whitespace/empty checks:");
      //  console.log("  Name:", isValidCustomerName);
      //console.log("  isValidManualRelationship:", isValidManualRelationship);
      // --- MODIFICATION END ---
      //let isFormValid = false;
      if (!Name) { // Changed condition
        isFormValid = false;
        form.setFields([
          {
            name: 'customerName100',
            errors: ['Please enter valid Customer Name'],
          },
        ]);
      } else {
        form.setFields([
          {
            name: 'customerName100',
            errors: [],
          },
        ]);
      }
      if (manualCustomerName && manualCustomerName.length > 200) {
        isFormValid = false;
        form.setFields([
          {
            name: 'customerName100',
            errors: [...form.getFieldError('customerName100'), 'Customer name cannot exceed 200 characters.'],
          },
        ]);
      }

      if (!isValidManualRelationship) { // Changed condition
        isFormValid = false;
        form.setFields([
          {
            name: 'relationship100',
            errors: ['Please enter valid relationship'],
          },
        ]);
      } else {
        form.setFields([
          {
            name: 'relationship100',
            errors: [],
          },
        ]);
      }

      if (!valEmail) {
        isFormValid = false;
        form.setFields([
          {
            name: 'email100',
            errors: ['Please enter valid Email address'],
          },
        ]);
      } else {
        form.setFields([
          {
            name: 'email100',
            errors: [],
          },
        ]);
      }
      if (!valMobile) {
        isFormValid = false;
        form.setFields([
          {
            name: 'mobileNumber100',
            errors: ['Please enter 10 digit Mobile No.'],
          },
        ]);
      } else {
        form.setFields([
          {
            name: 'mobileNumber100',
            errors: [],
          },
        ]);
      }
    }
    if (isFormValid) {
      if (recipients.length > 0) {
        setSendClicked(true);
        // setFeesSelected(false);

        const newFees = [...fees].filter(
          (x) => (x.amount != null && x.updatedAmount != null) || x.feeCode != null
        );
        newFees.forEach((x) => {
          if (x.updatedAmount) {
            x.amount = x.updatedAmount;
          }
        });

        // console.log(newFees);
        let createlink: CreateLinkPayload = {
          sourceId: sessionStorage.getItem('sourceId')?.toString(),
          amount: values.feeAmount != null ? Number(values.feeAmount) : 0,
          loanType: applicantDetails[0]?.loanType != null ? applicantDetails[0]?.loanType : '',
          crmSrNo: values.srNo,
          laNumber: values.loanNumber != null ? values.loanNumber : '',
          token:
            'MDc2NmRmZDItNzliZS00OWFmLTg3ZDYtNzE5YTk2Y2RjMGRiOiQyYSQwNCRzbFkxTXkwZjhiNFliNjVnQnpaYkEuaWtVUUNyYkJYNEE5N1BuQzNGVmRiajVaOGlSSFhscQ==',
          sessionId:
            sessionStorage.getItem('user') != null
              ? sessionStorage.getItem('user')?.toString()
              : '',
          feeType: value != 0 ? (value == 1 ? 'Upfront' : 'Post Disbursement') : null,
          userId:
            sessionStorage.getItem('userId') != null ? Number(sessionStorage.getItem('userId')) : 0,
          mode: 'Online',
          requestPurpose: 'Payment',
          paymentPurpose: values.paymentPurpose != null ? values.paymentPurpose : '',
          receipents: recipients,
          feesList: newFees,
          customerName: applicantDetails.filter((obj) => {
            return obj.accountName?.toUpperCase() === 'APPLICANT';
          })[0]?.customerName,
          emailId: applicantDetails.filter((obj) => {
            return obj.accountName?.toUpperCase() === 'APPLICANT';
          })[0]?.emailId,
          mobileNo: applicantDetails.filter((obj) => {
            return obj.accountName?.toUpperCase() === 'APPLICANT';
          })[0]?.mobileNumber,
          cif: applicantDetails.filter((obj) => {
            return obj.accountName === 'APPLICANT';
          })[0]?.cIFId,
          // allowedAmount: applicantDetails.filter((obj) => {
          //   return obj.accountName === 'APPLICANT';
          // })[0]?.allowedAmount,
          // totalAmount: applicantDetails.filter((obj) => {
          //   return obj.accountName === 'APPLICANT';
          // })[0]?.totalAmount,
          allowedAmount: applicantDetails[0]?.allowedAmount,
          totalAmount: applicantDetails[0]?.totalAmount,
        };
        // =================== 👨‍💻 CODE UPDATE START ===================
        // Add foreclosure dates to the payload if the purpose is 'Foreclosure'
        if (values.paymentPurpose === 'Foreclosure') {
          createlink.foreclosureRequestDate = values.foreclosureRequestDate
            ? values.foreclosureRequestDate.format('YYYY-MM-DDTHH:mm:ss')
            : null;
          createlink.foreclosureIssuanceDate = values.foreclosureIssuanceDate
            ? values.foreclosureIssuanceDate.format('YYYY-MM-DDTHH:mm:ss')
            : null;
        }
        debugger;
        if (!zero) {
          if (!blank) {
            createLink(createlink)
              .then((x) => {
                if (x.data.paymentRequestId > 0)
                  message.success('Your request has been sent successfully.');
                else
                  message.error(
                    'Something went wrong please retry or contact System Administrator'
                  );
                form.resetFields();
                setSearchClicked(false);
              })
              .finally(() => {
                setNewFees(initFees);
                setSendClicked(false);
                setFeeLoaded(false);
                setFeesSelected(false);
                setSearchClicked(false);
                isBlank(false);
                form.resetFields();
                navigate('/agent/create-link');
                recipients = [];
                setLoadedLoanNumber(null);
              });
          } else {
            message.warn('Amount cannot be Blank');
            setNewFees(initFees);
            setSendClicked(false);
            setFeeLoaded(false);
            setFeesSelected(false);
            setSearchClicked(false);
            isBlank(false);
            form.resetFields();
            navigate('/agent/create-link');
            recipients = [];
            setLoadedLoanNumber(null);
          }
        } else {
          message.warn('Amount cannot be Zero');
          setNewFees(initFees);
          setSendClicked(false);
          setFeeLoaded(false);
          setFeesSelected(false);
          setSearchClicked(false);
          isBlank(false);
          setZero(false);
          form.resetFields();
          navigate('/agent/create-link');
          recipients = [];
          setLoadedLoanNumber(null);
        }

        // form.resetFields();
      } else {
        message.error('Please select the Reciepents!!!');
      }
    }
  }

  function handleSearch() {
    const latestFees = [...fees];
    setNewFees(latestFees);
    const loanNumber = form.getFieldValue('loanNumber')?.toString();
    //const paymentPurpose = form.getFieldValue('paymentPurpose')?.toString();

    if (form.getFieldValue('loanNumber') != null && form.getFieldValue('paymentPurpose') != null) {
      setIsLoading(false);
      setSearchClicked(true);
      // setNewFees(initFees);
      // setFeeLoaded(false);
      // setFeesSelected(false);


      // setApplicantDetails([]);
      // recipients = [];
      //form.resetFields(['customerName100', 'email100', 'relationship100', 'mobileNumber100']);


      applicantPayload.loanNumber = form.getFieldValue('loanNumber')?.toString();
      applicantPayload.paymentPurpose = form.getFieldValue('paymentPurpose')?.toString();
      applicantPayload.partnerId = Number(sessionStorage.getItem('partnerId'));
      getApplicantDetails(applicantPayload).then((res) => {
        // setPagedList(res);
        // message.success('Success');

        if (res.data.length > 0) {
          res.data.forEach((element, index) => {
            element.key = index;
          });

          let d: ApplicantDetails = {
            loanType: res.data[0]?.loanType,
            eMISiPiAmount: res.data[0]?.eMISiPiAmount,
            overdueAmount: res.data[0]?.overdueAmount,
            totalAmount: res.data[0]?.totalAmount,
            currentMonthINST: res.data[0]?.currentMonthINST,
            allowedAmount: res.data[0]?.allowedAmount,
            loanBranch: res.data[0]?.loanBranch,
            key: 100,
          };
          res.data.push(d);
          setApplicantDetails(res.data);

          // --- ADDED CODE: Update form fields with new values ---
          const newFormValues: Record<string, any> = {};
          res.data.forEach(applicant => {
            // You need to map the new data to the correct form field names
            newFormValues['customerName' + applicant.key] = applicant.customerName;
            newFormValues['email' + applicant.key] = applicant.emailId;
            newFormValues['relationship' + applicant.key] = applicant.accountName;
            newFormValues['mobileNumber' + applicant.key] = applicant.mobileNumber;
          });
          form.setFieldsValue(newFormValues);
          // --- END ADDED CODE ---
          if (
            applicantPayload.paymentPurpose == 'Overdue' ||
            applicantPayload.paymentPurpose == 'Foreclosure'
          ) {
            form.setFieldValue('feeAmount', res.data[0]?.totalAmount);
          } else if (applicantPayload.paymentPurpose == 'ADVANCEEMI') {
            form.setFieldValue('feeAmount', res.data[0]?.currentMonthINST);
          }
          //  if (applicantPayload.paymentPurpose === 'Foreclosure') {
          //   setShowForeclosureDates(true);
          //}
          console.log(res);
          setLoadedLoanNumber(loanNumber);
          setIsLoading(true);
        } else {
          message.warn('The Loan No is Invalid.');
          form.resetFields();
          setSearchClicked(false);
          setLoadedLoanNumber(null);
        }
      });
    } else if (form.getFieldValue('loanNumber') == null) {
      message.error('Please enter Loan number!!!');
    } else if (form.getFieldValue('paymentPurpose') == null) {
      message.error('Please select Payment Purpose!!!');
    }
  }

  function handlePursposeChange(_e: any) {

    if (_e === 'Foreclosure') {
      setShowForeclosureDates(true);
    } else {
      setShowForeclosureDates(false);
    }
    //setShowForeclosureDates(false);
    if (_e == 'Fees') {
      form.setFieldValue('feeAmount', 0);
      setFeesSelected(true);
      setForeclosure(false);
    } else if (_e == 'PartPayment' || _e == 'Foreclosure') {
      form.setFieldValue('feeAmount', null);
      setForeclosure(true);
      setFeesSelected(false);
    } else {
      form.setFieldValue('feeAmount', null);
      setFeesSelected(false);
      setForeclosure(false);
    }
  }

  function handleManualName(_e: any) {
    manual.customerName = _e.value;
    applicantDetails.filter((x) => {
      if (x.key == 100) {
        x.customerName = _e.currentTarget.value;
      }
    });
    setManual(man);
    form.setFields([
      {
        name: 'customerName100',
        errors: [],
      },
    ]);
  }
  function handleManualEmail(_e: any) {
    const regex = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    const val = regex.test(_e.target.value);
    if (val) {
      manual.emailId = _e.target.value;
      applicantDetails.filter((x) => {
        if (x.key == 100) {
          x.emailId = _e.currentTarget.value;
        }
      });
      setManual(man);
      form.setFields([
        {
          name: 'email100',
          errors: [],
        },
      ]);
    }
    // else {
    //   //_e.stopPropagation();
    //   let appDetail = applicantDetails.filter(x => x.key == 100)[0];
    //   let defAppdetails = applicantDetails.filter(x => x.key != 100);

    //   if (appDetail) {
    //     appDetail.emailId = ""
    //     defAppdetails.push(appDetail);
    //   }
    //   setApplicantDetails(defAppdetails);
    //   //message.warn("Please Enter valid Email Address!");

    // }
  }

  function handleManualRel(_e: any) {
    // const regex = new RegExp(
    //   /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    // );
    // const val = regex.test(_e.value);
    // if (val) {

    //   manual.accountName = _e.value;
    applicantDetails.filter((x) => {
      if (x.key == 100) {
        x.accountName = _e.currentTarget.value;
      }
    });
    setManual(man);
    form.setFields([
      {
        name: 'relationship100',
        errors: [],
      },
    ]);


    // }
  }
  function handleManualMobile(_e: any) {
    const regex = new RegExp(/^[0-9]{10}$/);
    const val = regex.test(_e.target.value);
    if (val) {
      manual.mobileNumber = _e.target.value;
      applicantDetails.filter((x) => {
        if (x.key == 100) {
          x.mobileNumber = _e.currentTarget.value;
        }
      });
      setManual(man);
      form.setFields([
        {
          name: 'mobileNumber100',
          errors: [],
        },
      ]);
    }
    // else {
    //   _e.stopPropagation();
    //   let appDetail = applicantDetails.filter(x => x.key == 100)[0];
    //   let defAppdetails = applicantDetails.filter(x => x.key != 100);

    //   if (appDetail) {
    //     appDetail.mobileNumber = ""
    //     defAppdetails.push(appDetail);
    //   }
    //   //message.warn("Please enter 10 digit no.");

    // }
  }

  function handleManualFeeCode(_e: any, _x: any) {
    let updatedFeeCode = _x;

    let updatedFeeDesc = feeCodes.filter((x) => x.feeCode == updatedFeeCode)[0]?.feeDescription;

    const updatedFees = [...fees];

    updatedFees.forEach((x) => {
      if (x.key == _e) {
        x.feeCode = updatedFeeCode;
        x.feeDesc = updatedFeeDesc;
      }
    });

    setNewFees(updatedFees);
  }

  function handleSpecialChars(_e: any, _x: any) {
    debugger;
    let updatedFeeAmount = '';
    if (_x.shiftKey) {
      updatedFeeAmount = _x.currentTarget.value;
    } else {
      updatedFeeAmount = _x.currentTarget.value + String.fromCharCode(_x.keyCode);
    }
    const isNumber = /^\d*$/.test(updatedFeeAmount);
    if (!isNumber && _x.keyCode != 8 && _x.keyCode != 16) {
      message.destroy();
      message.warn('Special Characters are not allowed.');
      _x.currentTarget.value = updatedFeeAmount.replace(/\D/g, '');
    } else if (isNumber && Number(updatedFeeAmount) == 0 && updatedFeeAmount != '') {
      _x.currentTarget.value = _e;
      message.destroy();
      message.warn('Amount can not be zero.');
    }
  }
  function handleManualFeeAmount(_e: any, _x: any) {
    let updatedFeeAmount = _x.currentTarget.value;

    if (updatedFeeAmount != '') {
      const updatedFees = [...fees];

      updatedFees.forEach((x) => {
        if (x.key == _e && x.amount >= updatedFeeAmount) {
          x.updatedAmount = Number(updatedFeeAmount);
          x.active = !x.active;
        } else if (x.key == _e && x.amount < updatedFeeAmount) {
          message.destroy();
          message.warn('Can not pay more than Rs. ' + x.amount);
        }
      });
      updatedFees.sort((a, b) => Number(a.key) - Number(b.key));
      setNewFees(updatedFees);
    } else {
      message.destroy();
      message.warn('Amount can not be blank.');
    }
  }

  // const getFees = (): void => {
  //   // setFeeLoaded((isfeeLoaded) => isfeeLoaded = false);
  //   const latestfees = [...fees];

  //   let key = latestfees.length + 100;
  //   const newData: FeesDetails = {
  //     feeCode: undefined,
  //     feeDesc: undefined,
  //     amount: undefined,
  //     key: key,
  //   };

  //   latestfees.push(newData);

  //   if (latestfees.length > 0) {
  //     setNewFees(latestfees);
  //     console.log(fees);
  //     // setDataSource(latestfees);
  //   }
  //   // setFeeLoaded((isfeeLoaded) => isfeeLoaded = true);
  //   // return fees;
  // };

  const handleDelete = (key: any) => {
    let newData = [...fees];
    newData = newData.filter((item) => item.key !== key.key);
    setNewFees(newData);
  };

  const defaultColumns: ColumnsType<FeesDetails> = [
    {
      title: 'Fees Code',
      dataIndex: 'feeCode',
      render: (text, record) => {
        if (record.amount != undefined || record.amount == 0) {
          return (
            <InputNumber type="text" value={record.feeDesc} disabled={true} placeholder={text} />
          );
        } else {
          return (
            <Select
              options={feeCodes}
              defaultValue="Select"
              onChange={(_x) => handleManualFeeCode(record.key, _x)}
            ></Select>
          );
        }
      },
    },
    {
      title: 'Amount',
      dataIndex: 'feeAmount',
      render: (text, record) => {
        if (record.amount != undefined || record.amount == 0) {
          return (
            <InputNumber
              type="text"
              value={record.updatedAmount ? record.updatedAmount : record.amount}
              disabled={record.active}
              // readOnly={record.active}
              placeholder={text}
              onKeyUp={(_y) => handleSpecialChars(record.amount, _y)}
              onBlur={(_y) => handleManualFeeAmount(record.key, _y)}

            // max={record.amount}
            />
          );
        } else {
          return (
            <InputNumber
              type="text"
              value={record.amount}
              placeholder={text}
              onKeyUp={(_y) => handleManualFeeAmount(record.key, _y)}
            />
          );
        }
      },
    },
    {
      // title: () => {
      //   return (
      //     <Button onClick={getFees} type="primary">
      //       + Add
      //     </Button>
      //   );
      // },
      dataIndex: 'operation',
      render: (_, _record) =>
        fees.length >= 1 ? (
          <>
            <a onClick={() => handleEdit(_record)} style={{ margin: 10 }}>
              <EditOutlined />
            </a>
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(_record)}>
              <a>
                <DeleteOutlined />
              </a>
            </Popconfirm>
          </>
        ) : null,
    },
  ];

  const getFeesCharge = (e: RadioChangeEvent) => {
    setSendClicked(true);
    setFeeLoaded(false);
    // setNewFees((value) => {
    //   value = feesList.data;
    //   return value;
    // });
    let updatedFees: FeesDetails[];

    updatedFees = [...fees];
    updatedFees = [];
    // setNewFees(updatedFees);

    // const ne_fees: FeesDetails = {
    //   feeCode: undefined,
    //   feeDesc: undefined,
    //   amount: undefined,
    //   key: 100,
    // };

    // updatedFees = [ne_fees];

    setNewFees(updatedFees);

    if (form.getFieldValue('loanNumber')) {
      console.log('radio checked', e.target.value);
      setValue(e.target.value);
      const feetype: FeesPayload = {
        loanNo: form.getFieldValue('loanNumber')?.toString(),
        feeType: e.target.value == 1 ? 'Upfront' : 'PostDisbursement',
      };

      // getFeesCodes().then((x) => {
      //   if (x != null) {
      //     x.data.forEach((x) => {
      //       x.label = x.feeDescription;
      //       x.value = x.feeCode;
      //     });
      //     setFeeCodes(x.data);
      //   }
      //   // setCodeLoaded(true);
      // });

      getFeesChargeDetails(feetype)
        .then((res) => {
          if (res.data != null) {
            res.data.forEach((x, i) => {
              x.key = i;
              x.active = true;
            });

            // setFeeDetails(res);

            // res.data.push(newData);
            updatedFees = res.data;
            // setNewFees((value) => {
            //   value = res.data;
            //   return value;
            // });
            setFeeLoaded(true);
          }
        })
        .finally(() => {
          // updatedFees.push(ne_fees);
          setNewFees(updatedFees);

          // setFeeLoaded(true);
          setSendClicked(false);
        });
    } else {
      setFeeLoaded(false);
      setSendClicked(false);
      message.error('Please enter Loan Number first.');
    }
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: ApplicantDetails[]) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      recipients = selectedRows;
    },
    getCheckboxProps: (record: ApplicantDetails) => ({
      name: record.customerName,
    }),
  };

  const handleChange = (e: any) => {
    debugger;
    const inputValue = e.data;
    const newValue = inputValue.toUpperCase(); // Change the value to uppercase

    // Check if the input value contains any non-numeric characters
    if (!/^\d/.test(newValue)) {
      e.preventDefault(); // Prevent the update
      return;
    }
  };

  const handleEdit = (e: any) => {
    debugger;
    let noneditedFees = fees.filter((x) => x.feeCode !== e.feeCode);
    let editedFees = fees.filter((x) => x.feeCode === e.feeCode)[0];
    if (editedFees) {
      editedFees.active = !editedFees.active;
      noneditedFees.push(editedFees);
    }
    noneditedFees.sort((a, b) => Number(a.key) - Number(b.key));

    setNewFees(noneditedFees);
  };

  // const openBulkSend = () => {
  //   // setIsModalOpen(true);
  //   navigate('/app/overdueDashboard');
  // };

  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };

  // const handleCancel = () => {
  //   setIsModalOpen(false);
  // };

  // const handleSubmit = useCallback(
  //   async (values: FilterPayload) => {
  //     let updatedValues = { ...values };
  //     updatedValues.Username = sessionStorage.getItem('user')?.toString();
  //     updatedValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  //     setFilter(updatedValues);
  //     // form.resetFields();
  //   },
  //   []
  // );

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-10 offset-md-1 offset-sm-1">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Create Link</h2>
              <div className="submission-htmlForm" style={{ marginBottom: '50px' }}>
                {/* <Button onClick={openBulkSend} type="primary">
                  Trigger bulk links
                </Button> */}
                <Spin spinning={isSendClicked}>
                  <Form<LinkPayload>
                    form={form}
                    onFinish={handleSend}
                    layout="vertical"
                    scrollToFirstError
                    className="standard-forms"
                  >
                    <div className="row">
                      <p>
                        Link can be triggered up to 10 Lakhs Amount only, if the payable amount is
                        more than 10 Lakhs then split the amount and trigger more than one link to
                        customer.
                      </p>
                    </div>
                    <div className="row">
                      <div className="form-group col-xs-12 col-sm-6 col-md-6">
                        <div className="input-box">
                          <Form.Item
                            label={'Loan Number :'}
                            name="loanNumber"
                            className="fieldTitle"
                            rules={[{ required: true, message: 'Please enter Loan Number!' }]}
                          >
                            <Input placeholder={'Loan Number'} />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-4 col-md-4">
                        <div className="input-box">
                          <Form.Item
                            label={'Payment Purpose :'}
                            name="paymentPurpose"
                            className="fieldTitle"
                            rules={[{ required: true, message: 'Please Select PaymentPurpose!' }]}
                          >
                            <Select defaultValue="0" onChange={handlePursposeChange}>
                              <Option value="0">Select</Option>
                              <Option value="Fees">Fees</Option>
                              <Option value="Foreclosure">Foreclosure</Option>
                              <Option value="Overdue">Overdue</Option>
                              <Option value="PartPayment">PartPayment</Option>
                              <Option value="ADVANCEEMI">Advance EMI</Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-2 col-md-2">
                        <div className="input-box">
                          <Form.Item label={''} className="fieldTitle">
                            <Button
                              type="primary"
                              onClick={handleSearch}
                              style={{ marginTop: '42px' }}
                            >
                              {'Search'}
                            </Button>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-xs-12 col-sm-6 col-md-6">
                        <div className="input-box">
                          <Form.Item
                            label={'Amount:'}
                            name="feeAmount"
                            className="fieldTitle"
                            rules={[
                              {
                                required: isForeclosure ? true : false,
                                message: 'Please enter Amount!',
                              },
                            ]}
                          >
                            <InputNumber
                              placeholder={'Amount'}
                              id="amount"
                              disabled={isFeesSelected ? true : false}
                              style={{ border: '1px solid #dcdcdc' }}
                              onBeforeInput={handleChange}
                              ref={inputRef}
                              // 🟢 ADD THIS onChange handler to reset the error states
                              onChange={(val) => {
                                if (val !== null && val !== 0) {
                                  setZero(false);
                                }
                                if (val !== null) {
                                  isBlank(false);
                                }
                              }}
                              onBlur={(e) => {
                                debugger;
                                if (e.currentTarget.value.length == 0) {
                                  message.warn('Amount cannot be blank');
                                  isBlank(true);
                                }
                                if (e.currentTarget.value == '0') {
                                  message.warn('Amount cannot be zero');
                                  setZero(true);
                                }
                              }}
                            />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-6 col-md-6">
                        <div className="input-box">
                          <Form.Item
                            label={'Sr No :'}
                            name="srNo"
                            className="fieldTitle"
                            rules={[
                              {
                                required: isForeclosure ? true : false,
                                message: 'Please enter SrNo!',
                              },
                            ]}
                          >
                            <Input placeholder={'Sr No'} />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    {showForeclosureDates && (
                      <div className="row">
                        <div className="form-group col-xs-12 col-sm-6 col-md-6">
                          <div className="input-box">
                            <Form.Item
                              label={'Foreclosure Request Date :'}
                              name="foreclosureRequestDate"
                              className="fieldTitle"
                              rules={[
                                {
                                  required: true,
                                  message:
                                    'Please select Foreclosure Request Date!',
                                },
                              ]}
                            >
                              <DatePicker style={{ width: '100%' }}
                                disabledDate={disabledDate}
                                format="DD/MM/YYYY"
                              />
                            </Form.Item>
                          </div>
                        </div>
                        <div className="form-group col-xs-12 col-sm-6 col-md-6">
                          <div className="input-box">
                            <Form.Item
                              label={'Foreclosure Issuance Date :'}
                              name="foreclosureIssuanceDate"
                              className="fieldTitle"
                              rules={[
                                {
                                  required: true,
                                  message:
                                    'Please select Foreclosure Issuance Date!',
                                },
                              ]}
                            >
                              <DatePicker style={{ width: '100%' }}
                                disabledDate={disabledDate}
                                format="DD/MM/YYYY"
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    )}
                    {isFeesSelected ? (
                      <div className="row" id="divFeesInput">
                        <h5 className="search-heading" style={{ marginLeft: '16px' }}>
                          Select fees type
                        </h5>
                        <div className="">
                          <div className="input-box">
                            <label className="fieldTitle"></label>
                            <div
                              className=""
                              data-toggle="buttons"
                              style={{ paddingBottom: '10px', width: '100%' }}
                            >
                              <Radio.Group
                                onChange={getFeesCharge}
                                value={value}
                                className="col-xs-12 col-sm-6 col-md-6"
                              >
                                <label
                                  className="btn btn-primary col-md-3"
                                  style={{ marginRight: '10px' }}
                                >
                                  <Radio
                                    className="rblFeeType"
                                    id="FeeType"
                                    name="feeType"
                                    type="radio"
                                    value={1}
                                  ></Radio>
                                  Upfront
                                </label>
                                <label
                                  className="btn btn-primary col-md-5"
                                  style={{ marginRight: '10px' }}
                                >
                                  <Radio
                                    className="rblFeeType"
                                    id="FeeType"
                                    name="feeType"
                                    type="radio"
                                    value={2}
                                    style={{ width: '10%', alignContent: 'left' }}
                                  ></Radio>
                                  Post Disbursement
                                </label>
                              </Radio.Group>
                            </div>
                          </div>
                        </div>
                        {isfeeLoaded ? (
                          <>
                            {
                              <Table<FeesDetails>
                                dataSource={[...fees]}
                                columns={defaultColumns}
                                pagination={false}
                                style={{ maxWidth: '50%' }}
                              />
                            }
                          </>
                        ) : null}
                      </div>
                    ) : null}

                    {isSearchedClicked ? (
                      !isLoading ? (
                        <LoadingScreen />
                      ) : (
                        <>
                          <div className="row">
                            <div id="divContactDetails">
                              <div className="contacts">
                                <div className="">
                                  <div className="col-xs-12 col-sm-12 col-md-12">
                                    <h5 className="search-heading">
                                      Select contact from the below list to send Payment Link
                                    </h5>
                                    <div className="form-group">
                                      <div className="responsive-table">
                                        <Table<ApplicantDetails>
                                          rowSelection={{
                                            type: 'checkbox',
                                            ...rowSelection,
                                          }}
                                          dataSource={applicantDetails}
                                          columns={columns}
                                          pagination={false}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    ) : null}

                    <div className="payment-button">
                      <Button
                        type="primary"
                        className="proceed-btn"
                        id="btnSubmit"
                        htmlType="submit"
                        size="small"
                        style={{ height: '40px', width: '100px' }}
                      >
                        Send
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        type="primary"
                        id="btnClear"
                        className="proceed-btn"
                        size="small"
                        style={{ height: '40px', width: '100px', marginBottom: '10px' }}
                      >
                        Clear
                      </Button>
                    </div>
                  </Form>
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateLink;
